import { render, staticRenderFns } from "./Error404Page.vue?vue&type=template&id=4d6a9a4f&"
import script from "./Error404Page.vue?vue&type=script&lang=js&"
export * from "./Error404Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports